import { useCallback, useEffect, useRef, useState } from 'react'
import api from '../api/client'
import { useRealtime } from './useRealtime'

/** The unread count behind the Messages badge, kept current by the live socket. */
export function useUnreadMessages(enabled: boolean): number {
  const [count, setCount] = useState(0)
  const pending = useRef<ReturnType<typeof setTimeout> | null>(null)

  const refresh = useCallback(() => {
    if (!enabled) return
    api.messaging
      .unread()
      .then((r) => setCount(r.count))
      .catch(() => undefined)
  }, [enabled])

  // Bursts of events (a busy team chat) collapse into one request.
  const refreshSoon = useCallback(() => {
    if (pending.current) clearTimeout(pending.current)
    pending.current = setTimeout(refresh, 300)
  }, [refresh])

  useEffect(() => {
    refresh()
    window.addEventListener('focus', refresh)
    return () => {
      window.removeEventListener('focus', refresh)
      if (pending.current) clearTimeout(pending.current)
    }
  }, [refresh])

  useRealtime((event) => {
    if (event.type === 'message.created' && event.message.is_mine) return
    refreshSoon()
  }, enabled)

  return count
}
